<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="5">
            <v-text-field
              label="Local de Lotação"
              v-model="form.filters.nome"
              outlined
              dense
              @keyup.enter="buscarLotacoes"
            ></v-text-field>
          </v-col>

          <v-col cols="5">
            <v-autocomplete
              v-model="form.filters.gres"
              :items="form.lists.listGres"
              :item-text="'nome'"
              :item-value="'id'"
              label="GRE"
              multiple
              outlined
              dense
              @change="handleChangeGres"
              @keyup.enter="buscarLotacoes"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row class="d-flex justify-center mt-3">
          <sca-select-ativo
            :cols="5"
            :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
            v-model="form.filters.ativo"
            @enter="buscarLotacoes"
          ></sca-select-ativo>
          <v-col cols="5">
            <v-autocomplete
              v-model="form.filters.municipios"
              :items="form.lists.filteredListMunicipios"
              :item-text="'nome'"
              :item-value="'codigo'"
              label="Município"
              multiple
              outlined
              dense
              return-object
              @change="handleChangeMunicipios"
              @keyup.enter="buscarLotacoes"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarLotacoes()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterLotacao()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="headers"
        :items="form.lists.listLotacoes"
        :items-per-page="10"
        :footer-props="$footerProps"
        no-data-text="Não há registros a serem exibidos."
      >
        <template v-slot:[`item.ativo`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>

        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarLotacao(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterLotacao(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="`${item.ativo ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`"
            :small="true"
            @click="inativarAtivarLotacao(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarLotacaoDialog
      v-if="dialogManterLotacao.visible"
      :visible="dialogManterLotacao.visible"
      :content="dialogManterLotacao.content"
      :edit="dialogManterLotacao.edit"
      @onClose="dialogManterLotacao.close()"
      @onSave="buscarLotacoes()"
    ></CadastrarEditarLotacaoDialog>
    <VisualizarLotacaoDialog
      :visible="dialogVisualizarLotacao.visible"
      :content="dialogVisualizarLotacao.content"
      @onClose="dialogVisualizarLotacao.close()"
    ></VisualizarLotacaoDialog>
  </div>
</template>

<script>
import { Dialog } from '~/commons/classes/dialog';
import { Lotacao } from '~/commons/classes/lotacao';
import LotacaoService from '~/services/lotacao.service';
import GreMunicipioService from '~/services/gre-municipio.service';
import CadastrarEditarLotacaoDialog from './dialogs/CadastrarEditarLotacaoDialog.vue';
import VisualizarLotacaoDialog from './dialogs/VisualizarLotacaoDialog.vue';

export default {
  name: "ManterLotacoesView",
  mixins: [LotacaoService, GreMunicipioService],
  components: {
    CadastrarEditarLotacaoDialog,
    VisualizarLotacaoDialog
  },
  data: () => ({
    dialogManterLotacao: Dialog.Build(),
    dialogVisualizarLotacao: Dialog.Build(),
    form: {
      filters: {
        nome: null,
        ativo: null,
        gres: [],
        municipios: []
      },
      lists: {
        listGres: [],
        listLotacoes: [],
        listMunicipios: [],
        filteredListMunicipios: [],
      }
    },
    headers: [
      { text: "Local de Lotação", align: "center", value: "local" },
      { text: "Município", align: "center", value: "municipio" },
      { text: "GRE", align: "center", value: "gre" },
      { text: "Situação", align: "center", value: "ativo", sortable: false },
      { text: "Ações", align: "center", value: "acoes", sortable: false },
    ]
  }),
  methods: {
    buscarLotacoes() {
      this.$buscarLotacoes(this.montarParams()).then(({ data }) => this.form.lists.listLotacoes = data.resposta)
    },
    openDialogManterLotacao(lotacao) {
      lotacao
        ? this.$visualizarLotacao(lotacao.id).then(({ data }) => this.dialogManterLotacao.open(new Lotacao(data.resposta.lotacao), true))
        : this.dialogManterLotacao.open(Lotacao.Build());
    },
    openDialogVisualizarLotacao(lotacao) {
      this.$visualizarLotacao(lotacao.id).then(({ data }) => this.dialogVisualizarLotacao.open(data.resposta.lotacao));
    },
    buscarMunicipios() {
      this.$buscarGreMunicipios().then(({ data }) => {
        this.form.lists.listGres = data.resposta.gres;
        this.form.lists.listMunicipios = data.resposta.municipios;
        this.form.lists.filteredListMunicipios = data.resposta.municipios;
      });
    },
    inativarAtivarLotacao(lotacao) {
      this.$swal({
        text: `Deseja ${lotacao.ativo ? "inativar" : "ativar"} o registro?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarLotacao(lotacao.id).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.buscarLotacoes();
        });
      });
    },
    montarParams() {
      let params = {};

      params.local = this.form.filters.nome ?? null;
      params.ativo = this.form.filters.ativo;

      if (this.form.filters.gres.length) {
        params.gres = this.form.filters.gres.join(',');
      }

      if (this.form.filters.municipios.length) {
        params.municipios = this.form.filters.municipios.map(m => m.codigo).join(',');
      }

    return { params };
  },
    resetForm() {
      this.form.filters.nome = null;
      this.form.filters.ativo = null;
      this.form.filters.gres = [];
      this.form.filters.municipios = [];
      this.form.lists.listLotacoes = [];
      this.form.lists.filteredListMunicipios = [...this.form.lists.listMunicipios];
    },

    handleChangeGres(gres) {
      this.form.lists.filteredListMunicipios = this.form.lists.listMunicipios
        .filter(m => gres.includes(m.gre) || !gres.length);
      this.form.filters.municipios = this.form.filters.municipios
        .filter(m => gres.includes(m.gre) || !gres.length);
    },
    handleChangeMunicipios(municipios) {
      municipios.map(m => m.gre).forEach(gre => {
        if (!this.form.filters.gres.includes(gre)) {
          this.form.filters.gres.push(gre);
        }
      });
    },
  },
  mounted(){
    this.buscarMunicipios();
  }
};
</script>
